// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "sdl-sociedade-da-lanterna.firebaseapp.com",
  "projectId": "sdl-sociedade-da-lanterna",
  "storageBucket": "sdl-sociedade-da-lanterna.firebasestorage.app",
  "messagingSenderId": "796336762988",
  "appId": "1:796336762988:web:9415cf607c95d89b866849",
  "measurementId": "G-D9X17R05Y6",
  "apiKey": "AIzaSyCwrXSLC9JXU8VDRm-JWXzbIqIZQ4g1fXo"
};
